module.exports = __webpack_public_path__ + "img/product-inclusion.ab798a8c.png";